import { AbstractControl, ValidatorFn } from '@angular/forms';

export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: unknown } | null => {
    if (control && control.touched && control.value) {
      return matchControl(control);
    }
    return isControlTouch(control);
  };
}

function matchControl(control: AbstractControl) {
  let val = '';
  const key = 'value';

  if (Object.prototype.hasOwnProperty.call(control.value, key)) {
    val = control.value.value;
  } else {
    val = control.value;
  }

  return !val.match(/^[\w-]+(?:\.[\w-]+)*@([a-z0-9-]+\.)+[a-z]{2,13}$/i)
    ? {
        email: {
          value: val,
          match: '/^[w-]+(?:.[w-]+)*@([a-z0-9-]+.)+[a-z]{2,13}$/i'
        }
      }
    : null;
}

function isControlTouch(
  control: AbstractControl
): { [key: string]: unknown } | null {
  return !control.touched
    ? null
    : {
        email: {
          value: control.value,
          match: '/^[w-]+(?:.[w-]+)*@([a-z0-9-]+.)+[a-z]{2,13}$/i'
        }
      };
}
